import { ApiRoomContainer, ApiErrorResponse } from '@ibe/api';
import { decodeObjectBase64 } from '@ibe/services';

class PartialRepresentation {
  serviceCode?: string;
}

export const jumpToTop = (): void => {
  window.scroll(0, 0);
};

export const sumPaxes = (occupancy: ApiRoomContainer[]): number => {
  return occupancy.map(rc => rc.infants + rc.children + rc.adults).reduce((p, c) => p + c, 0);
};

export const getServiceCodeFromId = (id: string): string | undefined => {
  const { serviceCode } = decodeObjectBase64(PartialRepresentation, id);
  return serviceCode;
};

export const isErrorResponse = (obj: unknown): obj is ApiErrorResponse => {
  if (typeof obj !== 'object' || obj === null) return false;

  const candidate = obj as Record<string, unknown>;

  return (
    (typeof candidate.apiVersion === 'string' || candidate.apiVersion === undefined) &&
    (typeof candidate.code === 'string' || candidate.code === undefined) &&
    (typeof candidate.message === 'string' || candidate.message === undefined)
  );
};

export const wait = (delay?: number): Promise<void> => {
  return new Promise(resolve => {
    setTimeout(resolve, delay || 100);
  });
};
